import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/portaliServiziTop';
import { generateRoutes } from '../../../helpers/portaleModuleHelper';

const routes = generateRoutes('portaliServiziTop', selectors);

const list = _.values(routes.list).map((route) => ({
    ...route,
    requiredRoles: ['admin', 'developer', 'employee', 'amministrazione'],
    getComponent() {
        return new Promise((resolve) => {
            import(
                /* webpackChunkName: 'portaliServiziTop' */ `modules/portaliServiziTop/${route.componentPath}`
            ).then((response) => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('portaliServiziTop', routes.patterns);
routeRegister.addLinks('portaliServiziTop', links);

export default list;
